<template>
  <div>
    <div class="wrapper">
      <div class="animated fadeIn">
        <b-form @submit.prevent="addItem">
          <b-row>
            <b-col cols="12" class="mb-3">
              <b-button variant="primary" @click="$router.go(-1)" class="pull-left">Terug</b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-card>
                <template slot="header">
                  Chili Template toevoegen
                </template>
                <b-row>
                  <b-col cols="12" md="6">
                    <b-form-group label="Omschrijving">
                      <b-form-input type="text" required v-model="item.description"></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12" md="6">
                    <b-form-group label="E-mail">
                      <b-form-input type="text" v-model="item.email"></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12" md="6">
                    <b-form-group label="Telefoon">
                      <b-form-input type="text" v-model="item.phone"></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12" md="6">
                    <b-form-group label="Hoofdcontactpersoon">
                      <b-form-checkbox id="checkbox-1" v-model="item.is_main_contact" name="is_main_contact" value="1" unchecked-value="0">
                        Dit contactpersoon moet in de kolom voor algemene vragen weergegeven worden
                      </b-form-checkbox>
                    </b-form-group>
                  </b-col>
                </b-row>
                <template slot="footer">
                    <b-button type="submit" variant="success" class="pull-right" :disabled="saveButtonDisabled">Toevoegen</b-button>
                </template>
              </b-card>
            </b-col>
          </b-row>
        </b-form>
      </div>
    </div>
  </div>
</template>
<script>
  import { addData } from '../../api';

  export default {
    name: 'contact',



    data() {
      return {
        saveButtonDisabled: false,
        item: {
          is_main_contact: 0
        },
      };
    },
    methods: {
      async addItem() {
        this.saveButtonDisabled = true;

        let formData = new FormData();
        Object.keys(this.item).forEach(key => {
          formData.append(key, this.item[key]);
        });

        const request = await addData('contacts', formData);

        if (request.status === 201) {
          this.$router.push({ name: 'contacts.view', params: { id: request.data.data.id } });
        } else {
          this.saveButtonDisabled = false;
        }
      },
    },
  };
</script>

